import script from "./MinSale.vue?vue&type=script&setup=true&lang=js"
export * from "./MinSale.vue?vue&type=script&setup=true&lang=js"

import "./MinSale.vue?vue&type=style&index=0&id=868ca688&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-868ca688"]])

export default __exports__